<div #navbar *ngIf="showNavbar" class="navbar transparent-bg-navbar" [ngClass]="{'white-bg-navbar': !darkMode, 'white-bg-bottom-separator-navbar': !darkMode}">
  <!-- desktop -->
  <nav class="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6" aria-label="Global">
    <div class="flex items-center justify-between flex-1">
      <div class="flex items-center justify-between w-full lg:w-auto">
        <a routerLink="/">
          <div class="cursor-pointer">
            <img class="h-8 w-auto sm:h-10 logo" [ngClass]="{'filter-dark': !darkMode, 'logo-dark': logoDark}" src="/assets/images/logo.svg" alt="ahoracrypto logo">
          </div>
        </a>
        <div class="-mr-2 flex items-center lg:hidden">
          <button #triggerMenuButton type="button" class="rounded-md p-2 inline-flex items-center justify-center text-white focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <!-- Heroicon name: outline/menu -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      <div class="hidden space-x-4 lg:flex lg:ml-4">
        <ng-container *ngIf="showSections">
          <div class="navbarlink-hover explore-link">
            <div class="nav-link-bg"></div>
            <a routerLink="/cryptos/" (click)="closeExploreMenu(true)" [ngClass]="{'filter-dark': !darkMode}" (mouseenter)="exploreMenuVisible=true; openExploreMenu()" (mouseleave)="exploreMenuVisible=false; closeExploreMenu();" class="nav-link-2 w-nav-link font-normal text-white hover:text-gray-300">
              <div class="flex items-center justify-between flex-1">
                <div [ngClass]="{'filter-dark': !darkMode}" i18n="@@market">Market</div>
                <div [ngClass]="{'filter-dark': !darkMode}" class="pl-2 icon w-icon-dropdown-toggle"></div>
              </div>
            </a>
            <nav #exploreMenu class="dropdown-list w-dropdown-list" (mouseenter)="exploreMenuVisible=true;" (mouseleave)="exploreMenuVisible=false; closeExploreMenu();" style="margin-left: -120px; width: 850px; height: 298.933px; margin-top: -10px;">
              <div class="hover-top-surface">&nbsp;</div>
              <div *ngIf="currenciesList.length > 0">
                <div class="grid grid-cols-3 gap-2">
                  <a routerLink="/cryptos/{{currency.baseCurrency | lowercase}}" (click)="closeExploreMenu(true)"  *ngFor="let currency of currenciesList; let i=index">
                    <div class="navbar-market-coin">
                      <div class="flex items-center space-x-2">
                        <div>
                          <img *ngIf="currency?.baseCurrency != null" src="/assets/icons/currencies/color/{{currency.baseCurrency | lowercase}}.svg" loading="lazy" class="w-6 h-6">
                        </div>
                        <div class="flex-grow">
                          <div class="block" style="font-family: Tiempostext, sans-serif; font-size: 14px; font-weight: 700; color: #120747; display: inline-flex; align-items: center;">
                            {{currency.baseCurrency | cryptosymbol2name | async}}
                            <span class="text-span-18">{{currency.baseCurrency}}</span>
                          </div>
                          <div class="block text-black" style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 16px;">
                            <exchange-price [animatePriceChange]="false" [baseCurrency]="currency.baseCurrency" [quoteCurrency]="currency.quoteCurrency"></exchange-price>
                          </div>
                        </div>
                      </div>
                      <div class="flex items-center justify-center h-full">
                        <div class="block text-sm self-center stock-rate-navbar" [ngClass]="{'bg-green-custom': currency.last24hVariation > 0, 'bg-red-custom': currency.last24hVariation < 0}">
                            <stock-rate [style]="2" [baseCurrency]="currency.baseCurrency" [quoteCurrency]="currency.quoteCurrency"></stock-rate>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="flex justify-center mt-2">
                  <a routerLink="/cryptos/" (click)="closeExploreMenu(true)" class="navbar-show-more">Ver todas las criptomonedas<span class="text-span-20"></span></a>
                </div>
              </div>
              <div class="text-block-36" style="margin-right: 340px;"><strong></strong></div>
            </nav>
          </div>
          <div class="navbarlink-hover explore-link">
            <div class="nav-link-bg"></div>
            <a routerLink="/resources/" (click)="closeLearnMenu(true);" (mouseenter)="learnMenuVisible=true; openLearnMenu()" (mouseleave)="learnMenuVisible=false; closeLearnMenu();" class="nav-link-2 w-nav-link font-normal text-white hover:text-gray-300">
              <div class="flex items-center justify-between flex-1">
                <div [ngClass]="{'filter-dark': !darkMode}" i18n="@@learn">Learn</div>
                <div [ngClass]="{'filter-dark': !darkMode}" class="pl-2 icon w-icon-dropdown-toggle"></div>
              </div>
            </a>
            <nav #learnMenu class="dropdown-list w-dropdown-list" (mouseenter)="learnMenuVisible=true;" (mouseleave)="learnMenuVisible=false; closeLearnMenu();" style="margin-left: -280px; width: 850px; height: 298.933px; margin-top: -10px;">
              <div class="hover-top-surface">&nbsp;</div>
              <a *ngIf="highlightArticles.length > 0">
                <div class="grid gap-x-2" style="grid-template-columns: 33.3% 66.6%;">
                  <!-- First Column: Static Blog Entries -->
                  <div class="-mt-2">
                    <a routerLink="/resources/{{fixedContent[0]?.code}}" (click)="closeLearnMenu(true)">
                      <div class="navbar-blog mt-1.5">
                        <div class="flex items-center space-x-2">
                          <div style="width: 15px; height: 18px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="18">
                              <path d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/>
                            </svg>
                          </div>
                          <div class="flex-grow items-center" style="max-width: 100%;">
                            <div style="flex-grow: 1; min-width: 0;">
                              <div class="block article-name">
                                {{ fixedContent[0]?.name }}
                              </div>
                              <div class="block text-black" style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                                {{ fixedContent[0]?.excerpt }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                    <a routerLink="/resources/{{fixedContent[1]?.code}}" (click)="closeLearnMenu(true)">
                      <div class="navbar-blog mt-1.5">
                        <div class="flex items-center space-x-2">
                          <div style="width: 15px; height: 18px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="18">
                              <path d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/>
                            </svg>
                          </div>
                          <div class="flex-grow items-center" style="max-width: 100%;">
                            <div style="flex-grow: 1; min-width: 0;">
                              <div class="block article-name">
                                {{ fixedContent[1]?.name }}
                              </div>
                              <div class="block text-black" style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                                {{ fixedContent[1]?.excerpt }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>

                    <a routerLink="/resources/{{fixedContent[2]?.code}}" (click)="closeLearnMenu(true)">
                      <div class="navbar-blog mt-1.5" >
                        <div class="flex items-center space-x-2">
                          <div style="width: 15px; height: 18px;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="18">
                              <path d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/>
                            </svg>
                          </div>
                          <div class="flex-grow items-center" style="max-width: 100%;">
                            <div style="flex-grow: 1; min-width: 0;">
                              <div class="block article-name">
                                {{ fixedContent[2]?.name }}
                              </div>
                              <div class="block text-black" style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                                {{ fixedContent[2]?.excerpt }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <!-- Second Column: Dynamic Blog Entries -->
                  <div class="-mt-2 mr-2">
                    <a *ngFor="let article of highlightArticles; let i=index" routerLink="/resources/{{article?.code}}" (click)="closeLearnMenu(true)">
                      <div class="navbar-blog mt-1.5">
                        <div class="flex items-center space-x-2">
                          <div style="flex-shrink: 0; border-radius: 10px; width: 50px; height: 50px; overflow: hidden;">
                            <div>
                              <img src="{{article?.mainPictureUrl}}" loading="lazy">
                            </div>
                          </div>
                          <div class="flex flex-grow items-center" style="max-width: 100%;">
                            <div style="flex-grow: 1; min-width: 0;">
                              <div class="block article-name"  style="max-width: 470px;">
                                {{ article?.name }}
                              </div>
                              <div class="block text-black" style="font-family: Montserrat, sans-serif; font-size: 14px; line-height: 16px;">
                                {{ getTimeAgo(article?.published) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="flex justify-center mt-2">
                  <a routerLink="/resources/" (click)="closeLearnMenu(true)" class="navbar-show-more">Ver todo<span class="text-span-20"></span></a>
                </div>
              </a>
              <div class="text-block-36"><strong></strong></div>
            </nav>
          </div>
          <div class="navbarlink-hover">
            <div class="nav-link-bg"></div>
            <a href="javascript:void(null);" class="glightbox nav-link-2 w-nav-link font-normal text-white hover:text-gray-300">
              <div class="flex items-center justify-between flex-1">
                <div [ngClass]="{'filter-dark': !darkMode}" class="text-block-37"><strong></strong></div>
                <div [ngClass]="{'filter-dark': !darkMode}" i18n="@@how-does-it-works">How does it works</div>
              </div>
            </a>
          </div>
          <div class="navbarlink-hover">
            <div class="nav-link-bg"></div>
            <a [ngClass]="{'filter-dark': !darkMode}" routerLink="/help" class="nav-link-2 w-nav-link font-normal text-white hover:text-gray-300" i18n="@@help">Help</a>
          </div>
          <a *ngIf="userInSession == null || userInSession?.registrationStatus == 0" routerLink="/login" class="btn-2 nav-btn w-inline-block font-normal">
            <div class="text-block-37"><strong></strong></div>
            <div i18n>Access</div>
          </a>
          <a *ngIf="userInSession?.registrationStatus > 0" routerLink="/dashboard" class="btn-2 nav-btn w-inline-block font-normal">
            <div class="text-block-37"><strong></strong></div>
            <div i18n>Dashboard</div>
          </a>
          <!--
          <div *ngIf="userInSession != null" class="relative cursor-pointer h-10 w-10 rounded-full border-transparent" ng-reflect-ng-class="[object Object]"><img src="/assets/dashboard/images/default-avatar.svg" alt="user" class="h-full w-full rounded-full">
          </div>
          -->
        </ng-container>
      </div>
    </div>
  </nav>
  <div #dropdownMainMenu id="main-menu" class="hidden min-w-full absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
    <div class="rounded-lg shadow-md min-w-full bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
      <div class="px-5 pt-4 flex items-center justify-between">
        <div>
          <a routerLink="/">
            <img class="filter-dark h-8 w-auto" src="/assets/images/logo.svg" loading="lazy">
          </a>
        </div>
        <div class="-mr-2">
          <button (click)="closeMainMenu()" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
            <span class="sr-only">Close menu</span>
            <!-- Heroicon name: outline/x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <div class="px-2 pt-2 pb-3 space-y-1">
        <a routerLink="/" (click)="closeMainMenu()" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" i18n="@@home">Home</a>

        <a routerLink="/cryptos" (click)="closeMainMenu()" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" i18n>Crypto Market</a>
        <a routerLink="/resources" (click)="closeMainMenu()" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" i18n>Learn about Crypto</a>

        <a href="javascript:void(null);" (click)="closeMainMenu()" class="glightbox block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" i18n="@@how-does-it-works">How does it works</a>

        <a routerLink="/help" (click)="closeMainMenu()" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" i18n="@@help">Help</a>
      </div>
      <div>
        <a *ngIf="userInSession == null || userInSession?.registrationStatus == 0" (click)="closeMainMenu()" routerLink="/login" class="block w-full px-5 py-3 text-base text-center font-bold text-gray-600 bg-gray-50 hover:bg-gray-100" i18n>Access</a>
        <a *ngIf="userInSession?.registrationStatus > 0" routerLink="/dashboard" (click)="closeMainMenu()" class="block w-full px-5 py-3 text-base text-center font-bold text-gray-600 bg-gray-50 hover:bg-gray-100" i18n>Dashboard</a>
      </div>
      <div class="hidden">
        <a *ngIf="userInSession == null || userInSession?.registrationStatus == 0" href="javascript:void(null);" (click)="goToLogin()" class="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100" i18n="@@log-in"> Log in </a>
        <a *ngIf="userInSession?.registrationStatus > 0" (click)="logout(); closeMainMenu()" ahref="javascript:void(null);" [ngClass]="{'filter-dark': !darkMode}" class="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100" i18n="@@log-out">Logout</a>
      </div>
    </div>
  </div>
</div>
